'use strict';

import * as angular from 'angular';
var app = angular.module('noc.analysis', []);

app.controller('BaseAnalysisController', require('./base/baseAnalysisController'));

app.controller('GraphEditController', require('./chart/graph-edit/graphEditController'));
app.controller('GraphStackingController', require('./chart/stacking/graphStackingController'));
app.factory('GraphStackingStorage', require('./chart/stacking/graphStackingStorage'));
app.controller('ChartAnalysisController', require('./chart/chartAnalysisController'));
app.factory('ChartAnalysisFactory', require('./chart/chartAnalysisFactory'));
app.directive('chartMessagePanel', require('./chart/chartMessagePanelDirective'));
app.controller('TemplateController', require('./chart/templateController'));
app.controller('TemplateModalController', require('./chart/templateModalController'));

app.controller('CoverageMapAnalysisController', require('./coverage-map/coverageMapAnalysisController'));
app.factory('CoverageMapAnalysisFactory', require('./coverage-map/coverageMapAnalysisFactory'));
app.directive('coverageMapMessagePanel', require('./coverage-map/coverageMapMessagePanelDirective'));
app.factory('KmlExportFactory', require('./coverage-map/kmlExportFactory'));
app.factory('KmlFactory', require('./coverage-map/kmlFactory'));

app.controller('DocumentationController', require('./documentation/DocumentationController'));

app.controller('ExportCsvAnalysisController', require('./information/exportCsvAnalysisController'));

// app.controller('PeriodOverviewController', require('./overview/periodOverviewController'));
app.factory('TripOverviewFactory', require('./overview/tripOverviewFactory'));

app.factory('MessageDataFilter', require('./shared/messageDataFilter'));
app.factory('MessageDataRepository', require('./shared/messageDataRepository'));
app.factory('MessageDataStructure', require('./shared/messageDataStructure'));
app.factory('MessageDataStructureStorage', require('./shared/messageDataStructureStorage'));
app.factory('MessageDescriptorFactory', require('./shared/MessageDescriptorFactory'));
app.directive('messageSelector', require('./shared/messageSelectorDirective'));

app.controller('VuAnalysisController', require('./vu/vuAnalysisController'));
app.factory('VuFactory', require('./vu/vuFactory'));

export default app;